var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', _vm._l(_vm.value.history, function (history, index) {
    return _c('div', {
      key: 'history_element' + index + history.message + history.status
    }, [_c('time-line-item-text', {
      attrs: {
        "color": _vm.statusColorMap.get(history.status),
        "icon": _vm.statusIconMap.get(history.status),
        "text": _vm.simpleDoubleDigitDate(history.at)
      }
    }), _c('timeline-card', {
      staticClass: "mt-n4",
      attrs: {
        "title": _vm.$t("clearance.response.status.".concat(history.status, ".doneTitle")) + '! ' + _vm.$t("clearance.response.status.".concat(history.status, ".doneSubtitle"))
      }
    }, [history.message ? _c('v-list-item-subtitle', [history.message ? _c('div', {
      staticClass: "mt-2 mx-2 d-flex align-top"
    }, [_c('v-icon', {
      staticStyle: {
        "align-self": "flex-start",
        "margin-right": "8px"
      }
    }, [_vm._v(" mdi-format-quote-close ")]), _c('p', {
      staticStyle: {
        "white-space": "pre-line"
      }
    }, [_vm._v(" " + _vm._s(history.message) + " ")])], 1) : _vm._e()]) : _vm._e()], 1)], 1);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }